export interface TeamCreateReview {
  workflowId: string
  type?: string
  reason?: string
  pnr?: string
  ticketedOutsideAllowed?: boolean
}

export type BulkPreview =
  | { action: 'would-close'; workflowId: string; reason: string }
  | { action: 'skipped'; reason: string }

/** What the bulk close would do with a booking, from the reviews the Create tab would list for it. */
export function previewTicketedOutside(reviews: TeamCreateReview[]): BulkPreview {
  if (reviews.length === 0) {
    return { action: 'skipped', reason: 'No Create review is waiting on this booking' }
  }

  const closable = reviews.filter(review => review.type !== 'airline-direct-review')
  if (closable.length === 0) {
    return { action: 'skipped', reason: 'Airline direct review: record its ticket in the Create tab instead' }
  }

  if (closable.length > 1) {
    return { action: 'skipped', reason: 'More than one review is waiting: use the Create tab' }
  }

  const review = closable[0]!
  if (!review.ticketedOutsideAllowed) {
    return {
      action: 'skipped',
      reason: 'Entered the Create tab before this option existed: ask tech in #tech-support to close it',
    }
  }

  const pnr = review.pnr ? ` (PNR ${review.pnr})` : ''

  return { action: 'would-close', workflowId: review.workflowId, reason: `${review.reason || 'Create review'}${pnr}` }
}
